import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useShop } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const content = {
  it: {
    title: "Pagina non trovata",
    seoDesc: "La pagina che stai cercando non esiste o è stata spostata.",
    subtitle: "Errore 404",
    heading: "Ops, questa pagina non esiste",
    body: "L'indirizzo digitato potrebbe essere errato oppure la pagina è stata spostata o rimossa.",
    cta: "Torna alla home",
  },
  en: {
    title: "Page not found",
    seoDesc: "The page you are looking for does not exist or has been moved.",
    subtitle: "Error 404",
    heading: "Oops, this page doesn't exist",
    body: "The address you typed may be wrong, or the page has been moved or removed.",
    cta: "Back to home",
  },
};

const NotFound = () => {
  const { lang } = useShop();
  const { lp } = useLocale();
  const c = content[lang] || content.it;

  return (
    <div data-testid="not-found-page">
      <Seo title={c.title} description={c.seoDesc} />
      {/* Soft 404 (SPA): non indicizzare l'URL inesistente */}
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <PageTitle title="404" subtitle={c.subtitle} />

      <div className="idm-container" style={{ textAlign: "center", padding: "48px 20px 72px" }}>
        <h2 style={{ marginBottom: 12 }}>{c.heading}</h2>
        <p style={{ maxWidth: 560, margin: "0 auto 28px", opacity: 0.85 }}>{c.body}</p>
        <Link to={lp("/")} className="idm-btn-yellow" style={{ animation: "none" }} data-testid="notfound-home-btn">
          {c.cta}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
